import {
  ClienteDTO,
  DireccionDTO,
  SedeDTO,
} from '../../clientes/utilidades/clientes.models';

/* Estados de Domicilio */
export enum EstadoDomicilio {
  CANCELADO = 'cancelado',
  BODEGA = 'bodega',
  RUTA = 'ruta',
  DESPACHADO = 'despachado',
  ENTREGADO = 'entregado',
  FALLIDO = 'fallido',
  REPROGRAMADO = 'reprogramado',
}

/* Serialización readonly del modelo Domicilio */
export interface DomicilioDTO {
  id: number;
  fecha_creacion: string;
  referencia: string | null;
  referencia_display: string | null;
  titulo: string;
  tipo: string;
  tipo_display: string;
  prioridad: string;
  prioridad_display: string;
  estado: EstadoDomicilio;
  estado_display: string;
  orden: number | null;
  recaudo: number;
  direccion: DireccionDTO;
  cliente: ClienteDTO;
  origen: SedeDTO;
  servicio: string | null;
  notas: string | null;
  aliado: string | null;
  antecesor: number | null;
  sucesor: number | null;
  fecha_cancelacion: string | null;
  autor_cancelacion: string | null;
  motivo_cancelacion: string | null;
  observacion_cancelacion: string | null;
  fecha_enrutamiento: string | null;
  id_simpli: number | null;
  ruta: RutaDTO | null;
  tracking_id: string | null;
  errores: string | null;
  fecha_despacho: string | null;
  autor_despacho: string | null;
  fecha_checkout: string | null;
  comentarios_checkout: string | null;
  observacion_checkout: string | null;
  fotos_checkout: string | null;
  legalizado: boolean;
  archivo_legalizacion: string | null;
  fecha_legalizacion: string | null;
  autor_legalizacion: string | null;
  observacion_legalizacion: string | null;
}

/* Serialización readonly del modelo Ruta */
export interface RutaDTO {
  id: number;
  id_simpli: number;
  plan: number;
  vehiculo: VehiculoDTO;
}

/* Serialización readonly del modelo Vehículo */
export interface VehiculoDTO {
  id: number;
  id_simpli: number;
  nombre: string;
}
